module.exports = __webpack_public_path__ + "img/entrees.b2828148.svg";